import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH_SRI = ConstantList.API_EN_POINT + "/patient-service-register";
const API_PATH = ConstantList.API_EN_POINT + "/service-request-item";
const API_PATH_3 = ConstantList.API_EN_POINT + "/diagnostic-image-result";
const API_PATH_4 = ConstantList.API_EN_POINT + "/elastic-service-request-item-history";

export const pagingHistoryServiceRequestItem = (obj) =>
  axios.post(API_PATH_4 + "/search", obj);

export const exportReportTreamentItem = (obj) => {
  let url = API_PATH + "/export-excel-sri-treatment-report";
  return axios({
    url: url,
    method: "POST",
    responseType: "blob",
    data: obj,
  });
};

export const exportExcelCheckSuggestFee = (obj) => {
  let url = API_PATH + "/export-excel-check-suggest-fee";
  return axios({
    url: url,
    method: "POST",
    responseType: "blob",
    data: obj,
  });
};

export const getListgetListImageTrement = (searchObject) =>
  axios.post(API_PATH_3 + "/get-list", searchObject);

export const getListPrintRequest = (searchObject) =>
  axios.post(API_PATH_SRI + "/get-list-print-request", searchObject);

export const getServiceRequestByDay = (searchObject) =>
  axios.post(API_PATH_SRI + "/get-list-sv-request-day", searchObject);

export const removeSvItem = (id) =>
  axios.delete(API_PATH_SRI + "/remove-sv-item/" + id);

export const getListHospitalBedSVRequest = (obj) =>
  axios.post(API_PATH_SRI + "/get-list-hospital-bed-service-request", obj);

export const saveHospitalBedSVRequest = (obj) =>
  axios.post(API_PATH_SRI + "/save-hospital-bed-service-request", obj);

export const getHospitalBedSVRequestById = (id) =>
  axios.get(API_PATH_SRI + "/get-by-id/" + id);

export const updateSvItemToOrder = (obj) =>
  axios.post(API_PATH_SRI + "/update-sv-item-to-order", obj);

export const getListSvItem = (obj) =>
  axios.post(API_PATH_SRI + "/get-list-sv-item", obj);

export const updateSampleCodeForItem = (obj) =>
  axios.post(API_PATH_SRI + "/update-sample-code-of-sv-item", obj);

export const returnResultForListItem = (obj) =>
  axios.post(API_PATH_SRI + "/return-result-for-list-item", obj);

export const returnResultForItem = (obj) =>
  axios.post(API_PATH_SRI + "/return-result-for-item", obj);

export const cancelReturnResultForListItem = (obj) =>
  axios.post(API_PATH_SRI + "/cancel-return-result-for-list-item", obj);

export const cancelReturnResultForItem = (obj) =>
  axios.post(API_PATH_SRI + "/cancel-return-result-for-item", obj);

export const cancelSampledForListItem = (obj) =>
  axios.post(API_PATH_SRI + "/cancel-sampled-for-list-item", obj);

export const cancelReportForListItem = (obj) =>
  axios.post(API_PATH_SRI + "/cancel-report-for-list-item", obj);

export const getInitMedicalSupplyListItem = (obj) =>
  axios.post(API_PATH_SRI + "/get-init-medical-supply-by-list-item", obj);

export const updateHandleSampleCode = (obj) =>
  axios.post(API_PATH_SRI + "/update-handle-sample-code", obj);

export const getListServiceDesignation = (searchObject) =>
  axios.post(API_PATH_SRI + "/get-list-service-designation", searchObject);

export const returnResultCampaign = (searchObject) =>
  axios.post(API_PATH_SRI + "/return-result-by-campaign-id", searchObject);

export const checkDuplicateSampleCodeService = (searchObject) =>
  axios.post(
    API_PATH_SRI + "/check-duplicate-handle-sample-code",
    searchObject
  );

// API LA
export const saveServiceItem = (obj) =>
  axios.post(API_PATH_SRI + "/save-or-update", obj);

export const pagingServiceItem = (obj) =>
  axios.post(API_PATH_SRI + "/search-by-page", obj);

export const voidSvitemAndOrther = (id) =>
  axios.delete(API_PATH_SRI + "/remove/" + id);

export const pagingUncompletedRegisterService = (obj) =>
  axios.post(API_PATH_SRI + "/get-pa-service-register-uncompleted", obj);

export const getDefaultServicesByAppointmentCheckInDate = (obj) =>
  axios.post(
    API_PATH_SRI + "/get-default-services-by-appointment-check-in-date",
    obj
  );

export const allocateRoomsForUncompletedServices = (obj) =>
  axios.post(API_PATH_SRI + "/allocate-rooms-for-uncompleted-services", obj);

export const getLatestVisitBeforeAllocateRoom = (obj) =>
  axios.post(API_PATH_SRI + "/latest-visit-before-allocate-room", obj);

export const getLatestVisitBeforeAllocateRoomByDepartment = (obj) =>
  axios.post(API_PATH_SRI + "/latest-visit-by-patient-and-department", obj);

export const pagingServiceRequestItemByPatientServiceRegisterInfo = (obj) =>
  axios.post(API_PATH_SRI + "/paging-sri-by-service-register-info", obj);

export const pagingServiceRequestItemByPatientServiceRegisterInfoGroupDate = (
  obj
) =>
  axios.post(
    API_PATH_SRI + "/paging-sri-by-service-register-info-group-date",
    obj
  );

export const getListPaServiceRes = (searchObject) =>
  axios.post(API_PATH_SRI + "/get-list-pa-service-res", searchObject);

export const voidedServiceRequestItemFromPatientServiceRegister = (id) =>
  axios.delete(
    API_PATH_SRI + "/delete-sri-from-patient-service-register/" + id
  );

export const saveListPaServiceRes = (obj) =>
  axios.post(API_PATH_SRI + "/save-list-pa-service-res", obj);

export const getServiceRequestItemById = (id) =>
  axios.get(API_PATH + "/get-by-id/" + id);

export const pagingServiceRequestItem = (obj) =>
  axios.post(API_PATH + "/paging", obj);

export const sriTreatmentReport = (obj) =>
  axios.post(API_PATH + "/sri-treatment-report", obj);

export const receiveTreatment = (obj) =>
  axios.post(API_PATH + "/receive-treatment", obj);

// Cập nhật/chỉnh sửa chỉ định dịch vụ
export const updateServiceAllocationInfo = (obj) =>
  axios.put(API_PATH + "/update-service-allocation-info", obj);

// Cập nhật trạng thái chia tour cho chỉ định dịch vụ
export const updateTourInfo = (obj) =>
  axios.put(API_PATH + "/update-tour-info", obj);

export const getInitReportOfSvItem = (serviceRequestItem) =>
  axios.post(API_PATH + "/get-init-report-of-sv-item", serviceRequestItem);

export const updateParticipantsAndReportOfSvItem = (serviceRequestItem) =>
  axios.post(
    API_PATH + "/update-participants-and-report-of-sv-item",
    serviceRequestItem
  );

export const unLockService = (id) =>
  axios.get(API_PATH_SRI + "/un-lock-service/" + id);

export const lockService = (id) =>
  axios.post(API_PATH_SRI + "/lock-service/" + id);

export const searchByPageSync = (obj) =>
  axios.post(API_PATH_SRI + "/search-by-page-sync", obj);

export const pagingSync = (obj) => axios.post(API_PATH + "/paging-sync", obj);

export const pagingWarrantyRegisterService = (obj) =>
  axios.post(API_PATH_SRI + "/get-pa-service-register-have-warranty", obj);
